import { searchBrandMediaTypes } from '@/app/library/constants';
import {
  baseQueryParamMapping,
  defaultReportingPeriod,
} from '@/components/core/analytics/queryParamMapping';
import { getMetrics, METRICS } from '@/models/metrics.enum';
import { PLATFORM_CONNECTION } from '@/models/platform/platform-connection.enum';

export const useYourPosts = () => {
  const metrics = getMetrics('yourPosts');

  return {
    title: 'LinkedIn Posts',
    channelFilterKey: 'linkedin',
    filters: {
      brandMediaTypes: [searchBrandMediaTypes.LINKEDIN_OWNED],
      default: {
        captionContain: [],
        captionNotContain: [],
        contentTags: [],
        contentTagMatchType: 'ANY',
        postType: [],
        reportingPeriod: defaultReportingPeriod,
        sort: {
          sortOrder: 'DESC',
          selected: { value: 'DATE', label: 'Recently Published' },
        },
      },
      options: {
        postType: [
          { label: 'Carousel', value: 'MULTI_IMAGE' },
          { label: 'Document', value: 'DOCUMENT' },
          { label: 'Image', value: 'IMAGE' },
          { label: 'Link', value: 'LINK' },
          { label: 'Text', value: 'TEXT' },
          { label: 'Video', value: 'VIDEO' },
        ],
      },
      queryParamMapping: {
        ...baseQueryParamMapping,
        postType: { queryParamName: 'postType', type: 'array', elementType: 'string' },
        captionContain: {
          queryParamName: 'captionContain',
          type: 'array',
          elementType: 'string',
        },
        captionNotContain: {
          queryParamName: 'captionNotContain',
          type: 'array',
          elementType: 'string',
        },
      },
      scope: 'linkedinYourPosts',
      sortDetails: {
        options: [
          { label: 'Recently Published', value: 'DATE' },
          {
            title: 'Organic',
            children: metrics.all([
              METRICS.LINKEDIN.CLICK_THROUGH_RATE,
              METRICS.LINKEDIN.CLICKS,
              METRICS.LINKEDIN.COMMENTS,
              METRICS.LINKEDIN.ENGAGEMENT_RATE,
              METRICS.LINKEDIN.ENGAGEMENTS,
              METRICS.LINKEDIN.IMPRESSIONS,
              METRICS.LINKEDIN.LIKES,
              METRICS.LINKEDIN.SHARES,
              METRICS.LINKEDIN.UNIQUE_IMPRESSIONS,
              METRICS.LINKEDIN.VIDEO_VIEWS,
              METRICS.LINKEDIN.WATCH_TIME,
            ]),
          },
        ],
        default: {
          sortOrder: 'DESC',
          selected: { value: 'DATE', label: 'Recently Published' },
        },
      },
    },
    displayMetrics: metrics.all([
      METRICS.LINKEDIN.ENGAGEMENTS,
      METRICS.LINKEDIN.ENGAGEMENT_RATE,
      METRICS.LINKEDIN.IMPRESSIONS,
      METRICS.LINKEDIN.CLICK_THROUGH_RATE,
    ]),
    metricLabels: metrics.all(Object.values(METRICS.LINKEDIN)),
    download: {
      pdf: {
        fileName: 'yourLinkedInPostsPDF',
        type: 'linkedinYourPosts',
        label: 'Your LinkedIn Posts PDF',
        pendingKey: 'linkedinYourPostsReportPending',
      },
      csv: {
        fileName: 'yourLinkedInPostsCSV',
        type: 'linkedinYourPosts',
        label: 'Your LinkedIn Posts CSV',
        pendingKey: 'linkedinYourPostsCSVPending',
      },
    },
    platformConnection: PLATFORM_CONNECTION.LINKEDIN,
  };
};
